// import { useEffect, useState } from "react";

// const Toast = ({ message, type = "success", onClose }) => {
//   const [renderMessage, setRenderMessage] = useState("");

//   useEffect(() => {
//     // 🔥 force screen reader detection
//     setRenderMessage("");

//     const timer = setTimeout(() => {
//       setRenderMessage(message);
//     }, 50);

//     return () => clearTimeout(timer);
//   }, [message]);

//   // useEffect(() => {
//   //   const timer = setTimeout(onClose, 2500);
//   //   return () => clearTimeout(timer);
//   // }, [onClose]);

//   return (
//     <div
//       role={type === "error" ? "alert" : "status"}
//       aria-live={type === "error" ? "assertive" : "polite"}
//       aria-atomic="true"
//       style={{
//         position: "fixed",
//         top: "30px",
//         right: "20px",
//         backgroundColor: type === "error" ? "#f44336" : "#4caf50",
//         color: "#fff",
//         padding: "14px 18px",
//         borderRadius: "8px",
//         zIndex: 9999,
//         minWidth: "280px",
//       }}
//     >
//       {renderMessage}
//     </div>
//   );
// };

// export default Toast;

import { useEffect, useState } from "react";

const Toast = ({ message, type = "success", onClose, duration = 3000 }) => {
  const [renderMessage, setRenderMessage] = useState("");
  const [progress, setProgress] = useState(100);
  const isError = type === "error";
  const isWarning = type === "warning";

  useEffect(() => {
    setRenderMessage("");
    const timer = setTimeout(() => setRenderMessage(message), 50);
    return () => clearTimeout(timer);
  }, [message]);

  useEffect(() => {
    const start = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const percent = 100 - (elapsed / duration) * 100;
      setProgress(percent);

      if (elapsed >= duration) {
        clearInterval(interval);
        onClose?.();
      }
    }, 16);

    return () => clearInterval(interval);
  }, [duration, onClose]);

  // 🎨 Theme config (clean + scalable)
  const theme = isError
    ? {
      title: "Error",
      color: "#d32f2f",
      bgSoft: "#fdecea",
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#d32f2f">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 
            10 10 10 10-4.48 10-10S17.52 2 
            12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
        </svg>
      ),
    }
    : isWarning
      ? {
        title: "Warning",
        color: "#ed6c02",
        bgSoft: "#fff4e5",
        icon: (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="#ed6c02">
            <path d="M1 21h22L12 2 1 
            21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
          </svg>
        ),
      }
      : {
        title: "Success",
        color: "#2e7d32",
        bgSoft: "#edf7ed",
        icon: (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="#2e7d32">
            <path d="M12 2C6.48 2 2 6.48 2 
            12s4.48 10 10 10 10-4.48 
            10-10S17.52 2 12 2zm-1 
            15l-5-5 1.41-1.41L11 
            14.17l5.59-5.59L18 
            10l-7 7z" />
          </svg>
        ),
      };

  return (
    <div
      role={isError ? "alert" : "status"}
      aria-live={isError ? "assertive" : "polite"}
      aria-atomic="true"
      style={{
        position: "fixed",
        top: "60px",
        right: "24px",
        width: "320px",
        background: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
        overflow: "hidden",
        zIndex: 9999,
        animation: "toastSlide 0.35s ease",
        border: "1px solid #eee",
      }}
    >
      {/* Content */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "12px",
          padding: "16px",
        }}
      >
        {/* Icon */}
        <div
          style={{
            minWidth: "36px",
            height: "36px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: theme.bgSoft,
          }}
        >
          {theme.icon}
        </div>

        {/* Text */}
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#222",
              marginBottom: "4px",
            }}
          >
            {theme.title}
          </div>

          <div
            style={{
              fontSize: "13px",
              color: "#555",
              lineHeight: "1.4",
            }}
          >
            {renderMessage}
          </div>
        </div>

        {/* Close */}
        <button
          onClick={onClose}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "16px",
            color: "#999",
          }}
        >
          ×
        </button>
      </div>

      {/* Progress bar */}
      <div
        style={{
          height: "3px",
          width: `${progress}%`,
          background: theme.color,
          transition: "width 0.1s linear",
        }}
      />
    </div>
  );
};

export default Toast;